export default __webpack_public_path__ + "static/media/tray.64e951c6.svg";